import axios from 'axios';

const profile = {
    state: {
        profile: {
            role: null,
            avatar: null,
            title: null,
            website: null,
            linkedin: null,
            facebook: null,
            instagram: null,
            bio: null
        }
    },
    mutations: {
        SET_PROFILE(state, payload) {
            state.profile = {
                ...payload
            }
        }
    },
    actions: {
        fetchProfile: async ({
            commit
        }) => {

            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                }
            }

            try {

                const username = localStorage.getItem('username')

                const payload = await axios.post(`${process.env.VUE_APP_API}/profile/me`, {
                    username
                }, config)

                // se non è mai stato editato il profilo -> skip
                if (payload.data > 0) {
                    commit('SET_PROFILE', payload.data)
                }

                return {
                    status: 200,
                    message: 'Success',
                    data: payload.data
                }

            } catch (e) {
                return {
                    status: 500,
                    message: 'Error',
                    error: e
                }
            }
        },

        updateProfile: async ({
            commit
        }, profile) => {

            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                }
            }

            try {
                const username = localStorage.getItem('username')

                const payload = await axios.post(`${process.env.VUE_APP_API}/profile/update`, {
                    username,
                    profile
                }, config)

                commit('SET_PROFILE', payload.data)

                return {
                    status: 200,
                    message: 'Success',
                    data: payload.data
                }

            } catch (e) {
                return {
                    status: 500,
                    message: 'Error',
                    error: e
                }
            }
        }
    },
    getters: {
        getProfile: state => state.profile,
    }
}

export default profile